import ArrowDown from "Components/ArrowDown/ArrowDown";
import "./SliderHeader.css";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SliderHeader = (homeData) => {
  const { t } = useTranslation("contact");

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-visible");
            } else {
              entry.target.classList.remove("animate-visible");
            }
          });
        },
        { threshold: 0.2 } // Trigger animation when 20% of the section is visible
      );
  
      const sections = document.querySelectorAll(".animate-section");
      sections.forEach((section) => observer.observe(section));
  
      return () => observer.disconnect(); // Cleanup
    }, []);
  return (
    <>
    <div id="main"></div>
    {/* 951px */}
      <div className="banner-main-area--1 md:h-[100%]">
        <div className="banner-one section-padding bg-image h-[90vh] lg:h-[100%]  ">
        <div className="video-bg overlay-bg animate-section opacity-0 transition-opacity duration-1000">
        <video
          loop
          muted
          playsInline
          // @ts-ignore
          autoPlay="autoplay"
          className="w-full h-full object-cover"
        >
          <source src="/Video.mp4" type="video/mp4" />
        </video>
      </div>
          <div className="info-banner relative z-1 scale-[85%] flex flex-col gap-6 items-end animate-section opacity-0 transition-opacity duration-1000 lg:min-h-[65vh] justify-end">
          <div className=" flex flex-col gap-6 items-center mx-auto my-0 ">
      {/* Title */}
      <span className="flex w-full text_bold_Bukra justify-center items-start text-center  text-4xl sm:text-5xl md:text-6xl font-semibold text-white leading-tight animate-section opacity-0 transition-opacity duration-1000 ">
        {homeData?.homeData?.data.title}
      </span>

      {/* Description */}
      <span className="flex w-full justify-center text_small_Bukra leading-[29px] pt-4 items-start text-center  text-[1rem]  font-normal text-white animate-section opacity-0 transition-opacity duration-1000 lg:w-[80%]">
      {homeData?.homeData?.data.description}
      </span>
    </div>
  <Link to={"/contactus"} className=" border  border-1 29LT_Bukra bg-[#fff] font-normal text-[#0d6b70]  relative whitespace-nowrap pointer flex px-12 py-3 gap-2 justify-center items-center rounded-full border-white mx-auto my-5  hover:bg-[#0d6b70] hover:text-[#fff] hover:border-none transition-transform duration-300 hover:scale-90 ">
    {t('contact')}
  </Link>

{/* <ArrowDown/> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SliderHeader;
